var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsedSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 4.83333,
    fill: "white",
    stroke: "#1454B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54169,
    y: 7.875,
    width: 17.5,
    height: 1.75,
    rx: 0.875,
    fill: "#1454B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54169,
    y: 13.125,
    width: 17.5,
    height: 1.75,
    rx: 0.875,
    fill: "#1454B8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54169,
    y: 18.375,
    width: 17.5,
    height: 1.75,
    rx: 0.875,
    fill: "#1454B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedSelected);
export default __webpack_public_path__ + "static/media/collapsed-selected.8a50b5a516a726fc0341f40329ccbf5c.svg";
export { ForwardRef as ReactComponent };